"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _mixins = require("../mixins");
var _helpers = require("../helpers");
var _excluded = ["height", "className", "outsideBorder"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CELL_HEIGHT = "34px";
var cellMixin = (0, _styledComponents.css)(["", ";", ";", ";padding:", ";display:inline-flex;align-items:center;box-sizing:border-box;overflow:hidden;white-space:", ";border-left:1px solid transparent;&:not(:first-child){border-left-color:", ";}"], _mixins.colorMixin, _mixins.backgroundMixin, _mixins.paddingMixin, function (props) {
  return "".concat(props.theme.spaces.xs, " ").concat(props.theme.spaces.s);
}, function (props) {
  return props.shouldFitTextInColumn ? "pre-line" : "nowrap";
}, function (props) {
  return props.theme.colors[props.rowIdx % 2 !== 0 ? "border" : "backgroundFourth"];
});
var ResizeHandler = _styledComponents["default"].div.withConfig({
  displayName: "DivTable__ResizeHandler",
  componentId: "sc-1valdj3-0"
})(["position:absolute;right:0;top:0;height:100%;width:10px;cursor:col-resize;user-select:none;touch-action:none;&::after{content:\"\";width:3px;height:100%;background:", ";opacity:0;position:absolute;right:-1px;top:0;}", ""], function (props) {
  return props.theme.colors.tableHeadText;
}, function (props) {
  return props.isResizing && (0, _styledComponents.css)(["&::after{background:", ";opacity:1 !important;transform:translateX(", "px);}"], function (props) {
    return props.theme.colors.primary;
  }, props.handlePosition);
});
var HeadCell = _styledComponents["default"].div.attrs(function (props) {
  return _objectSpread({}, (0, _helpers.getDataHookProp)(props.automationHook));
}).withConfig({
  displayName: "DivTable__HeadCell",
  componentId: "sc-1valdj3-1"
})(["", ";", ";display:flex !important;width:auto !important;min-height:51px;border-top:1px solid ", ";align-items:center;position:relative;", " ", ""], cellMixin, (0, _mixins.colorMixin)("tableHeadText"), function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.forceWidth && (0, _styledComponents.css)(["width:", " !important;"], props.forceWidth);
}, function (props) {
  return props.isResizing && "overflow: visible;";
});
var Head = _styledComponents["default"].div.withConfig({
  displayName: "DivTable__Head",
  componentId: "sc-1valdj3-2"
})([""]);
var Body = _styledComponents["default"].div.withConfig({
  displayName: "DivTable__Body",
  componentId: "sc-1valdj3-3"
})(["position:relative;height:", "px;min-width:fit-content;"], function (props) {
  return props.h;
});
var Cell = _styledComponents["default"].div.attrs(function (props) {
  return _objectSpread({}, (0, _helpers.getDataHookProp)(props.automationHook));
}).withConfig({
  displayName: "DivTable__Cell",
  componentId: "sc-1valdj3-4"
})(["", ";word-break:break-word;font-size:", ";", " position:relative;", ""], cellMixin, function (props) {
  return props.theme.fontSizes.base;
}, function (props) {
  return props.width && (0, _styledComponents.css)(["width:", ";"], props.width);
}, function (props) {
  return props.isEditable && (0, _styledComponents.css)(["&:hover::after{content:\"\";position:absolute;left:0;bottom:0;height:1px;width:100%;background-color:", ";}input{width:100%;border:none;font-size:inherit;background:transparent;padding:0;&:focus{outline:none;}}"], function (props) {
    return props.theme.colors.focus;
  });
});
var RowWrapper = _styledComponents["default"].div.attrs(function (props) {
  return {
    style: {
      transform: "translateY(".concat(props.start, "px)")
    }
  };
}).withConfig({
  displayName: "DivTable__RowWrapper",
  componentId: "sc-1valdj3-5"
})(["display:block;position:absolute;top:0;left:0;min-width:100%;"]);
var Row = _styledComponents["default"].div.withConfig({
  displayName: "DivTable__Row",
  componentId: "sc-1valdj3-6"
})(["", ";", ";width:auto !important;display:flex;transition:all 1s ease-in-out;border-top:1px solid ", ";background:", ";&:first-child{border-top:none;}&:last-child{border-bottom:1px solid ", ";}", ";", ";"], _mixins.backgroundMixin, (0, _mixins.colorMixin)("text"), function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors[props.index % 2 === 0 ? "backgroundTertiary" : "backgroundPrimary"];
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.highlightHover && (0, _styledComponents.css)(["&:hover{background-color:", ";}"], props.backgroundColor ? (0, _helpers.darkenSafe)(0.1, (0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary")) : props.theme.colors.backgroundSecondary);
}, function (props) {
  return props.cursor && (0, _styledComponents.css)(["cursor:", ";"], props.cursor);
});
var CurrentItemSeparator = _styledComponents["default"].div.withConfig({
  displayName: "DivTable__CurrentItemSeparator",
  componentId: "sc-1valdj3-7"
})(["height:1px;border-top:1px solid ", ";"], function (props) {
  return props.theme.colors.primary;
});
var CurrentItemRow = (0, _styledComponents["default"])(Row).withConfig({
  displayName: "DivTable__CurrentItemRow",
  componentId: "sc-1valdj3-8"
})(["width:100% !important;height:", ";color:", ";background-color:", ";display:flex;align-items:center;gap:", ";", "{flex-grow:1;}span{flex-shrink:1;margin:", " 0;}"], CELL_HEIGHT, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.backgroundPrimary;
}, function (props) {
  return props.theme.spaces.base;
}, CurrentItemSeparator, function (props) {
  return props.theme.spaces.s;
});
var CurrentItemSeparatorRow = function CurrentItemSeparatorRow(props) {
  return /*#__PURE__*/_react["default"].createElement(CurrentItemRow, _extends({
    key: "currentItem"
  }, props), /*#__PURE__*/_react["default"].createElement(CurrentItemSeparator, null), /*#__PURE__*/_react["default"].createElement("span", null, "Current ", props.item || "Item"), /*#__PURE__*/_react["default"].createElement(CurrentItemSeparator, null));
};
CurrentItemSeparatorRow.propTypes = {
  item: _propTypes["default"].string
};
var ContainerOuter = _styledComponents["default"].div.withConfig({
  displayName: "DivTable__ContainerOuter",
  componentId: "sc-1valdj3-9"
})(["overflow:auto hidden;display:flex;height:", ";", " & > *{flex:1;}"], function (props) {
  return props.height || "calc(100% - 64px)";
}, function (props) {
  return props.outsideBorder && (0, _styledComponents.css)(["border:1px solid ", ";border-radius:", ";", " ", "{border-top:none;}", " > ", ":last-child{border-bottom:none;}"], props.theme.colors.border, props.theme.borderRadius.base, Head, HeadCell, Body, Row);
});
var propTypes = {
  // For a fixed height table that scrolls vertically. Fallback: 100% - 64px
  height: _propTypes["default"].string,
  // Will be added by styled-components' `styled`
  className: _propTypes["default"].string,
  // Defines if table should have an outside border
  outsideBorder: _propTypes["default"].bool
};
var DivTable = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var height = _ref.height,
    className = _ref.className,
    outsideBorder = _ref.outsideBorder,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ContainerOuter, {
    className: className,
    height: height,
    outsideBorder: outsideBorder
  }, /*#__PURE__*/_react["default"].createElement("div", _extends({}, other, {
    forwardRef: ref,
    role: "table"
  })));
});
DivTable.propTypes = propTypes;
DivTable.Body = Body;
DivTable.Cell = Cell;
DivTable.CurrentItemSeparatorRow = CurrentItemSeparatorRow;
DivTable.Head = Head;
DivTable.HeadCell = HeadCell;
DivTable.ResizeHandler = ResizeHandler;
DivTable.Row = Row;
DivTable.RowWrapper = RowWrapper;
var _default = DivTable;
exports["default"] = _default;